var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"titulo":"Pendências","loading":_vm.loading},on:{"close":_vm.close}},[_c('ListaPendencias',{attrs:{"box_id":_vm.box_id,"item":_vm.item,"readOnly":_vm.readOnly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }